const POSTCODE_REGEX =
  /^(GIR[ ]?0AA)$|^([A-PR-UWYZ][0-9][ ]?[0-9][ABD-HJLNPQ-UW-Z]{2})$|^([A-PR-UWYZ][0-9][0-9][ ]?[0-9][ABD-HJLNPQ-UW-Z]{2})$|^([A-PR-UWYZ][A-HK-Y0-9][0-9][ ]?[0-9][ABD-HJLNPQ-UW-Z]{2})$|^([A-PR-UWYZ][A-HK-Y0-9][0-9][0-9][ ]?[0-9][ABD-HJLNPQ-UW-Z]{2})$|^([A-PR-UWYZ][0-9][A-HJKS-UW0-9][ ]?[0-9][ABD-HJLNPQ-UW-Z]{2})$|^([A-PR-UWYZ][A-HK-Y0-9][0-9][ABEHMNPRVWXY0-9][ ]?[0-9][ABD-HJLNPQ-UW-Z]{2})$/

const EMAIL_REGEX = /^[a-z0-9._%+-]+@((?:[-a-z0-9]+\.)+[a-z]{2,})$/i

const CAR_REGISTRATION_REGEX = /(^[A-Za-z0-9\s]{1,8}$)/

const UK_PHONE_REGEX = /^(?:0|\+?44)(?:\d\s?){9,10}$/

export default {
  email: {
    pattern: {
      value: EMAIL_REGEX,
      message: 'Please enter a valid email address',
    },
  },
  postcode: {
    pattern: {
      value: POSTCODE_REGEX,
      message: 'Please enter a valid postcode',
    },
  },
  carRegistration: {
    pattern: {
      value: CAR_REGISTRATION_REGEX,
      message: 'Please enter a valid car registration',
    },
  },
  phoneNumber: {
    pattern: {
      value: UK_PHONE_REGEX,
      message: 'Please enter a valid UK phone number',
    },
  },
}
